import { Component, Inject, ViewChild } from '@angular/core';
import { ResponsiveService } from '../../../services/responsive.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiQuery } from '../../../web-services/api/api.query';
import { TranslatorService } from '../../../services/translator_service';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-cluster-data-modal',
  imports: [TranslatePipe,MatDividerModule,ScrollingModule,MatExpansionModule,RTLDivDirectiveDirective,CommonModule],
  templateUrl: './cluster-data-modal.html',
  styleUrl: './cluster-data-modal.scss',
})
export class ClusterDataModal {
  allExpandState: boolean = false;
  translationsObj;
	currentLang;
  isMobile: Boolean;
  chosenCluster: Array<any> = [];
  dataBackUp = [];
  allDataExpanded : boolean = false;
	usageType = 1;
  @ViewChild(MatAccordion,{static: false}) accordion: MatAccordion;

  constructor(private dialogRef: MatDialogRef<ClusterDataModal>,private translator: TranslatorService,
    private responsiveService: ResponsiveService,@Inject(MAT_DIALOG_DATA) public data: any,private apiQuery:ApiQuery) {
      this.dialogRef.disableClose = true;
      this.translator.currentLangEmitter$
      .subscribe(async value=>{						
        this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
        this.currentLang = value;	
      }); 
    }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
    this.apiQuery.user$.subscribe(user => {
      if (!user) {
        return;
      }
      this.usageType = user["usage_type_id"];
    });

    this.chosenCluster = this.data.item;
    this.dataBackUp = this.chosenCluster['bins'];
  }

  onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}

  closeModal(){
		this.dialogRef.close();
	}

  applyFilter = (filterValue: string) => {	
    this.data.item.bins = this.dataBackUp.filter((item) => item.bin_name.toString().includes(filterValue));
	}

  expandAllData(){
    this.allDataExpanded = !this.allDataExpanded;
  }
}
